var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBelfastTaxiToursPrices(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 1024 1024",
    className: "icon",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M853.333333 874.666667H170.666667c-46.933333 0-85.333333-38.4-85.333334-85.333334V343.466667c0-27.733333 12.8-53.333333 36.266667-70.4L512 0l390.4 273.066667c23.466667 14.933333 36.266667 42.666667 36.266667 70.4V789.333333c0 46.933333-38.4 85.333333-85.333334 85.333334z",
    fill: "#78909C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M298.666667 21.333333h426.666666v661.333334H298.666667z",
    fill: "#AED581"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M277.333333 0v704h469.333334V0H277.333333z m426.666667 661.333333H320V42.666667h384v618.666666z",
    fill: "#558B2F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M725.333333 64c0 36.266667-6.4 64-42.666666 64s-64-27.733333-64-64 27.733333-42.666667 64-42.666667 42.666667 6.4 42.666666 42.666667zM341.333333 21.333333c36.266667 0 64 6.4 64 42.666667s-27.733333 64-64 64-42.666667-27.733333-42.666666-64 6.4-42.666667 42.666666-42.666667z",
    fill: "#558B2F"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M512 170.666667m-42.666667 0a42.666667 42.666667 0 1 0 85.333334 0 42.666667 42.666667 0 1 0-85.333334 0Z",
    fill: "#558B2F"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M512 426.666667m-128 0a128 128 0 1 0 256 0 128 128 0 1 0-256 0Z",
    fill: "#558B2F"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M853.333333 874.666667H170.666667c-46.933333 0-85.333333-38.4-85.333334-85.333334V362.666667l426.666667 277.333333 426.666667-277.333333v426.666666c0 46.933333-38.4 85.333333-85.333334 85.333334z",
    fill: "#CFD8DC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBelfastTaxiToursPrices);
export default __webpack_public_path__ + "static/media/belfast-taxi-tours-prices.4035c8000e7f7736e7613ab4c720e7c3.svg";
export { ForwardRef as ReactComponent };